import {
  Button,
  Checkbox,
  Drawer,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
} from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import CustomActiveInactiveRadio from '../../../../../../shared/form-controls/custom-active-inactive-radio/Custom-Active-Inactive-Radio';
import CustomExpirySelect from '../../../../../../shared/form-controls/custom-expiry-select/Custom-Expiry-Select';
import CustomRadioWithCustomValues from '../../../../../../shared/form-controls/custom-radio/CustomRadioWithCustomValues';
import CustomTextField from '../../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import './Digital-Checkin.scss';
import ERegForm from './Digital-Checkin-Drawer/E-Reg-Form';
import DocumentType from './Digital-Checkin-Drawer/Document-Type';
import { useDispatch, useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../../../../property/propertySlice';
import {
  digitalCheckinConfigSelector,
  fetchDigitalCheckinConfigs,
  setDigitalCheckinConfigs,
} from '../../../../configurationSlice';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import {
  getDigitalCheckinConfigs,
  updateDigitalCheckinConfigs,
} from '../../../../../../utils/IntegrationsAPIUtils';
import CustomSelect from '../../../../../../shared/form-controls/custom-select/Custom-Select';
import { integrationSources } from '../../../../../../constants/HotelServicesConst';
import { formDataValidate } from '../../../../../../utils/formUtils';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import LinearProgressBar from '../../../../../../shared/progress-bar/Progress';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';

const EMAIL = 'EMAIL';
const HOTEL_URL = 'HOTEL_URL';
const FIXED = 'FIXED';
const PERCENT = 'PERCENT';
const EREG_FORM = 'e-Registration Form';
const DOC_FORM = 'Document Type Form';
const FIXED_AMOUNT = 'FIXED_AMOUNT';
const VARIED_AMOUNT = 'VARIED_AMOUNT';
const ID_VERIFICATION = 'ID_VERIFICATION';
const VACCINATION_CARD = 'VACCINATION_CARD';
const PCR_REPORT = 'PCR_REPORT';

const DigitalCheckin = ({ showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const selectedHotel = useSelector(selectedHotelSelector);
  const [integratioTypeFieldName, setIntegrationTypeFieldName] = useState('Select');
  const configs = useSelector(digitalCheckinConfigSelector);
  const [digitalCheckin, setDigitalCheckin] = useState('');
  const [loading, setLoading] = useState(true);
  const [docDetails, setDocDetails] = useState([]);
  const [toggleState, setToggleState] = useState({
    type: null,
    status: false,
    obj: null,
  });
  const [tabValue, setTabValue] = useState(0);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    integrationSource: {
      value: '',
      fieldName: 'Integration Source',
      errors: {},
      validations: [],
    },
    integrationSourceSelected: {
      value: '',
      fieldName: '',
      errors: {},
      validations: [],
    },
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
    apiIntegrationHotelId: {
      value: '',
      fieldName: 'Hotel ID',
      errors: {},
      validations: ['required'],
    },
    apiIntegrationUrl: {
      value: '',
      fieldName: 'URL',
      errors: {},
      validations: [],
    },
    checkInAvailability: {
      value: '',
      fieldName: 'Check-in Availability',
      errors: {},
      validations: [],
    },
    personalisation: {
      value: true,
      fieldName: 'Personalisation',
      errors: {},
      validations: [],
    },
    holdAmount: {
      value: 'FIXED_AMOUNT',
      fieldName: 'Hold Amount',
      errors: {},
      validations: [],
    },
    amountPerNight: {
      value: '',
      fieldName: 'Add hold amount per night',
      errors: {},
      validations: ['required', 'positiveOnly'],
    },
    incidentals: {
      value: '',
      fieldName: 'Incidentals',
      errors: {},
      validations: ['positiveOnly'],
    },
    incidentalsType: {
      value: FIXED,
      fieldName: 'Incidentals',
      errors: {},
      validations: [],
    },
    documentTypePrimaryGuest: {
      value: [],
      fieldName: 'Document type(s) for Identity Verification - Primary Guest',
      errors: {},
      validations: [],
    },
    accompanyingGuestDetails: {
      value: true,
      fieldName: 'Accompanying Guest Details',
      errors: {},
      validations: [],
    },
    idVerification: {
      value: true,
      fieldName: 'ID Verification',
      errors: {},
      validations: [],
    },
    covid19CheckDoc: {
      value: true,
      fieldName: 'Covid-19 Check Documents',
      errors: {},
      validations: [],
    },
    covid19PCRReport: {
      value: false,
      fieldName: 'PCR Report',
      errors: {},
      validations: [],
    },
    covid19VaccineCard: {
      value: false,
      fieldName: 'Vaccination Card',
      errors: {},
      validations: [],
    },
    eRegDestinationType: {
      value: '',
      fieldName: 'e-Registration Destination',
      errors: {},
      validations: [],
    },
    eRegDestinationEmail: {
      value: '',
      fieldName: 'Enter email address',
      errors: {},
      validations: [],
    },
    eRegDestinationNetwork: {
      value: '',
      fieldName: 'Enter cloud directory link',
      errors: {},
      validations: [],
    },
  });

  useEffect(() => {
    if (selectedHotel) {
      fetchDigitalCheckin();
    }
  }, [selectedHotel]);

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const fetchDigitalCheckin = async () => {
    try {
      dispatch(stepUpLoaderCount());
      const res = await getDigitalCheckinConfigs(selectedHotel);
      dispatch(setDigitalCheckinConfigs(res.data.getHotelSystemsDigitalCheckinConfig));
    } catch (err) {
      dispatch(setDigitalCheckinConfigs(null));
    } finally {
      setLoading(false);
      dispatch(stepDownLoaderCount());
    }
  };

  const handleChange = (e, field) => {
    const currField = { ...formData[field] };
    currField.value = e.target.checked;
    setFormData({ [field]: currField });
  };

  const handleChangePrimaryGuest = (e, object) => {
    const userValue = e.target.checked;
    const docDetailsCopy = docDetails.map((doc) => {
      const currItem = { ...doc };
      if (currItem.name === object.name && currItem.code === object.code) {
        currItem.status = userValue;
        return currItem;
      }
      return doc;
    });
    setDocDetails(docDetailsCopy);
  };

  const getERegDestinationValue = () => {
    const type = formData.eRegDestinationType.value;
    if (type === EMAIL) {
      return formData.eRegDestinationEmail.value;
    }
    if (type === HOTEL_URL) {
      return formData.eRegDestinationNetwork.value;
    }
    return '';
  };

  const convertEnumToBoolean = (value) => {
    return value === 'active' ? true : false;
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const refactorPayload = () => {
    return {
      hotelId: selectedHotel,
      checkInAvailability: formData?.checkInAvailability?.value,
      personalisation: convertEnumToBoolean(formData?.personalisation?.value),
      holdAmountConfig: {
        type: formData.holdAmount?.value,
        value:
          formData.amountPerNight?.value !== 0 ? parseFloat(formData.amountPerNight?.value) : 0,
        currency: 'USD', // No options to change
        incidentals: {
          type: formData.incidentalsType.value,
          value: formData.incidentals.value || 0,
        },
      },
      guestDocumentTypes: docDetails,
      accompanyingGuestDetails: {
        status: convertEnumToBoolean(formData.accompanyingGuestDetails.value),
        features: ['idVerification'].map((feature) => {
          return {
            name: formData[feature]?.fieldName,
            required: formData[feature]?.value,
          };
        }),
      },
      covid19Documents: {
        status: convertEnumToBoolean(formData.covid19CheckDoc.value),
        features: ['covid19PCRReport', 'covid19VaccineCard'].map((feature) => {
          return {
            name: formData[feature]?.fieldName,
            required: formData[feature]?.value,
          };
        }),
      },
      eRegistrationDestination: {
        key: formData.eRegDestinationType.value,
        value: getERegDestinationValue(),
      },
      apiIntegration: {
        hotelId: formData.apiIntegrationHotelId?.value,
        url: formData.apiIntegrationUrl?.value,
      },
      integrationSource: {
        type: formData?.integrationSource?.value,
        value: formData?.integrationSourceSelected?.value,
      },
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedHotel) return false;
    if (!validate()) return false;
    try {
      dispatch(stepUpLoaderCount());
      const payload = await refactorPayload();
      updateDigitalCheckinConfigs(payload).then((res) => {
        dispatch(fetchDigitalCheckinConfigs(selectedHotel));
        notificationManager('success', 'Digital Checkin updated successfully');
      });
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager('danger', 'Unable to update Digital Checkin');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleOnChange = (field, input) => {
    if (formData[field]) {
      const dataCopy = { ...formData[field] };
      dataCopy.value = input;
      setFormData({ [field]: dataCopy });
    }
  };

  const handleDrawer = (type, data) => {
    setToggleState({ status: true, obj: data, type: type });
  };

  const onDrawerToggle = (type, status, obj) => {
    setToggleState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setToggleState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case EREG_FORM:
        return (
          <ERegForm
            hotelId={selectedHotel}
            data={digitalCheckin?.eRegistrationForm}
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
          />
        );
      case DOC_FORM:
        return (
          <DocumentType
            hotelId={selectedHotel}
            data={digitalCheckin?.guestDocumentTypes}
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  useEffect(() => {
    if (digitalCheckin) {
      const formDataCopy = { ...formData };
      formDataCopy.integrationSource.value = digitalCheckin?.integrationSource?.type;
      formDataCopy.integrationSourceSelected.value = digitalCheckin?.integrationSource?.value;
      formDataCopy.apiIntegrationHotelId.value = selectedHotel;
      formDataCopy.apiIntegrationUrl.value = digitalCheckin?.apiIntegration?.url;

      formDataCopy.personalisation.value = digitalCheckin?.personalisation ? 'active' : 'inactive';
      formDataCopy.holdAmount.value = digitalCheckin?.holdAmountConfig?.type || FIXED_AMOUNT;
      formDataCopy.amountPerNight.value =
        digitalCheckin?.holdAmountConfig?.value !== 0
          ? digitalCheckin?.holdAmountConfig?.value
          : '';
      formDataCopy.incidentals.value =
        digitalCheckin?.holdAmountConfig?.incidentals?.value !== 0
          ? digitalCheckin?.holdAmountConfig?.incidentals?.value
          : '';
      formDataCopy.incidentalsType.value =
        digitalCheckin?.holdAmountConfig?.incidentals?.type ?? '';
      formDataCopy.accompanyingGuestDetails.value = digitalCheckin?.accompanyingGuestDetails?.status
        ? 'active'
        : 'inactive';
      formDataCopy.idVerification.idVerification =
        digitalCheckin?.accompanyingGuestDetails?.features.find(
          (item) => item.name === ID_VERIFICATION,
        )?.required;
      formDataCopy.covid19CheckDoc.value = digitalCheckin?.covid19Documents?.status
        ? 'active'
        : 'inactive';
      formDataCopy.covid19PCRReport.value = digitalCheckin?.covid19Documents?.features.find(
        (item) => item.name === PCR_REPORT,
      )?.required
        ? 'active'
        : 'inactive';
      formDataCopy.covid19VaccineCard.value = digitalCheckin?.covid19Documents?.features.find(
        (item) => item.name === VACCINATION_CARD,
      )?.required
        ? 'active'
        : 'inactive';
      formDataCopy.checkInAvailability.value = digitalCheckin?.checkInAvailability;
      const eRegDes = { ...digitalCheckin?.eRegistrationDestination };
      formDataCopy.eRegDestinationType.value = eRegDes?.key;
      if (eRegDes.key === EMAIL) {
        formDataCopy.eRegDestinationEmail.value = eRegDes?.value;
      }
      if (eRegDes.key === HOTEL_URL) {
        formDataCopy.eRegDestinationNetwork.value = eRegDes?.value;
      }
      setFormData(formDataCopy);
    }
  }, [digitalCheckin]);

  useEffect(() => setDigitalCheckin(configs), [configs]);

  useEffect(() => {
    if (digitalCheckin) {
      setDocDetails(digitalCheckin?.guestDocumentTypes);
    }
  }, [digitalCheckin]);

  useEffect(() => {
    const fieldName = `Select ${formData?.integrationSource?.value ?? ''}`;
    setIntegrationTypeFieldName(fieldName);
  }, [formData]);

  const onChangeHoldAmount = (e) => {
    const incidentals = { ...formData.incidentals };
    if (e.value === FIXED_AMOUNT)
      incidentals.value =
        digitalCheckin?.holdAmountConfig?.incidentals?.value !== 0
          ? digitalCheckin?.holdAmountConfig?.incidentals?.value
          : '';
    setFormData({ holdAmount: e, incidentals });
  };

  return loading ? (
    <div className='pt-4 col-12'>
      <LinearProgressBar />
    </div>
  ) : (
    <>
      <Drawer
        anchor={'right'}
        open={toggleState.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(toggleState)}
      </Drawer>
      <form className='digital-checkin'>
        <div className='col-12 hotel-service-tab-section'>
          <div className='col col-xl-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Integration Settings' />
              <Tab label='Configurable features' />
            </Tabs>
          </div>
        </div>

        {tabValue === 0 && (
          <div className='mx-4'>
            <IntegrationSource
              formData={formData}
              setFormData={setFormData}
              section='Digital Check-In'
              headTitle='Integration Source'
              showLoader={showLoader}
            />
          </div>
        )}
        {tabValue === 1 && (
          <div className='mx-4'>
            <div className='hotel-service-section'>
              <div className='hotel-service-subtitle mb-2'>
                {formData.checkInAvailability.fieldName}
              </div>
              <CustomExpirySelect
                item={formData.checkInAvailability}
                onExirySelectChange={(e) => {
                  setFormData({ checkInAvailability: e });
                }}
              />
            </div>

            <div className='hotel-service-section'>
              <div className='hotel-service-subtitle'>{formData.personalisation.fieldName}</div>
              <CustomActiveInactiveRadio
                item={formData.personalisation}
                handleRadioButton={(e) => {
                  setFormData({ personalisation: e });
                }}
              />
            </div>

            <div className='hotel-service-section'>
              <div className='hotel-service-subtitle'>{formData.holdAmount.fieldName}</div>
              <CustomRadioWithCustomValues
                item={formData.holdAmount}
                handleRadioButton={(e) => onChangeHoldAmount(e)}
                options={[
                  { id: FIXED_AMOUNT, name: 'Fixed Amount' },
                  { id: VARIED_AMOUNT, name: 'Varied Amount' },
                ]}
              />
              <div className='d-flex flex-row align-items-center'>
                <CustomTextField
                  item={formData.amountPerNight}
                  handleInputChange={(e) => {
                    setFormData({ amountPerNight: e });
                  }}
                  className='col-md-3'
                />
                {formData.holdAmount.value === VARIED_AMOUNT && (
                  <>
                    <span className='col-md-1 text-center pt-1'>+</span>
                    <TextField
                      className='col-md-4 mt-2'
                      value={formData.incidentals.value}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <div className='digital-checkin-button-group'>
                              <Button
                                onClick={(e) => handleOnChange('incidentalsType', FIXED)}
                                variant='contained'
                                color={formData?.incidentalsType?.value === FIXED ? 'primary' : ''}
                                className={`digital-checkin-button-group-item ${
                                  formData?.incidentalsType?.value === FIXED ? 'active-toggle' : ''
                                }`}
                              >
                                Fixed
                              </Button>
                              <Button
                                onClick={(e) => handleOnChange('incidentalsType', PERCENT)}
                                variant='contained'
                                color={
                                  formData?.incidentalsType?.value === PERCENT ? 'primary' : ''
                                }
                                className={`digital-checkin-button-group-item ${
                                  formData?.incidentalsType?.value === PERCENT
                                    ? 'active-toggle'
                                    : ''
                                }`}
                              >
                                %
                              </Button>
                            </div>
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => handleOnChange('incidentals', e.target.value)}
                      label={formData.incidentals?.fieldName}
                    />
                  </>
                )}
              </div>
            </div>

            <div className='hotel-service-section d-flex flex-row justify-content-between'>
              <div>
                <div className='hotel-service-subtitle'>
                  {formData.documentTypePrimaryGuest.fieldName}
                </div>
                {docDetails &&
                  docDetails.map((doc, i) => (
                    <div
                      key={i}
                      className='d-flex flex-row w-100 align-items-center mt-1 justify-content-between'
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            checked={doc?.status}
                            onChange={(e) => handleChangePrimaryGuest(e, doc)}
                            name={doc?.name}
                          />
                        }
                        label={doc?.name}
                      />
                      <span>{doc.code}</span>
                    </div>
                  ))}
              </div>
              <div>
                <span
                  className='pe-2 text-decoration-underline digital-checkin-toggle'
                  onClick={(e) => handleDrawer(DOC_FORM, '')}
                >
                  Edit Document Type
                </span>
                <EditIcon />
              </div>
            </div>

            <div className='hotel-service-section'>
              <div className='hotel-service-subtitle'>
                {formData.accompanyingGuestDetails.fieldName}
              </div>
              <CustomActiveInactiveRadio
                item={formData.accompanyingGuestDetails}
                handleRadioButton={(e) => {
                  setFormData({ accompanyingGuestDetails: e });
                }}
              />
              {formData.accompanyingGuestDetails.value === 'active' && (
                <div>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          checked={formData.idVerification.value}
                          onChange={(e) => handleChange(e, 'idVerification')}
                          name={formData.idVerification.fieldName}
                        />
                      }
                      label={formData.idVerification.fieldName}
                    />
                  </FormGroup>
                </div>
              )}
            </div>

            <div className='hotel-service-section'>
              <div className='hotel-service-subtitle'>
                <span>{formData.covid19CheckDoc.fieldName}</span>
                <span className='mx-4'>
                  <Tooltip title='Check only if mandatory' placement='right'>
                    <InfoIcon style={{ fontSize: '14px' }} />
                  </Tooltip>
                </span>
              </div>
              <CustomActiveInactiveRadio
                item={formData.covid19CheckDoc}
                handleRadioButton={(e) => {
                  setFormData({ covid19CheckDoc: e });
                }}
              />
              {formData.covid19CheckDoc.value === 'active' && (
                <div className='col-md-8'>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          checked={formData.covid19PCRReport.value}
                          onChange={(e) => handleChange(e, 'covid19PCRReport')}
                          name={formData.covid19PCRReport.fieldName}
                        />
                      }
                      label={formData.covid19PCRReport.fieldName}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          checked={formData.covid19VaccineCard.value}
                          onChange={(e) => handleChange(e, 'covid19VaccineCard')}
                          name={formData.covid19VaccineCard.fieldName}
                        />
                      }
                      label={formData.covid19VaccineCard.fieldName}
                    />
                  </FormGroup>
                </div>
              )}
            </div>

            <div className='hotel-service-section d-flex flex-row justify-content-between'>
              <div>
                <div className='hotel-service-subtitle'>
                  {formData.eRegDestinationType.fieldName}
                </div>
                <CustomRadioWithCustomValues
                  item={formData.eRegDestinationType}
                  handleRadioButton={(e) => {
                    setFormData({ eRegDestinationType: e });
                  }}
                  options={[
                    { id: EMAIL, name: 'Email' },
                    { id: HOTEL_URL, name: 'Hotel Network Path' },
                  ]}
                />
                <div className='w-100'>
                  {formData.eRegDestinationType.value === EMAIL && (
                    <CustomTextField
                      item={formData.eRegDestinationEmail}
                      handleInputChange={(e) => {
                        setFormData({ eRegDestinationEmail: e });
                      }}
                    />
                  )}
                  {formData.eRegDestinationType.value === HOTEL_URL && (
                    <CustomTextField
                      item={formData.eRegDestinationNetwork}
                      handleInputChange={(e) => {
                        setFormData({ eRegDestinationNetwork: e });
                      }}
                    />
                  )}
                </div>
              </div>
              <div>
                <span
                  className='pe-2 text-decoration-underline digital-checkin-toggle'
                  onClick={(e) => handleDrawer(EREG_FORM, '')}
                >
                  Edit e-Reg form
                </span>
                <EditIcon />
              </div>
            </div>
            <div className='row mt-auto px-1 w-100 pb-3'>
              <div className='col-md-12 mt-3  d-flex justify-content-start'>
                <Button
                  variant='contained'
                  type='button'
                  color='primary'
                  size='large'
                  onClick={(e) => handleSubmit(e)}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default DigitalCheckin;
